import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from 'services';
import { useAuth } from 'hooks/auth';
import { multiSelectorOptionsMapper, optionsMapper } from './utils';

type Carrier = {
  id: number;
  tradeName: string;
  document: string;
}

export const useCarrierOptions = () => {
  const { token } = useAuth();

  const fetchCarriers = React.useCallback(async () => {
    const { data } = await api.get<Carrier[]>('/carriers?asList=1', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((carrier: Carrier) => ({
      value: carrier.id,
      label: `${carrier.tradeName} - ${carrier.document}`,
    }));
  }, [token]);

  const { isPending, data } = useQuery({
    queryKey: ['fetchCarriers'],
    queryFn: () => fetchCarriers(),
  });

  return {
    singleSelectOptions: data ? data.map(optionsMapper) : [],
    multiSelectOptions: data ? data.map(multiSelectorOptionsMapper) : [],
    loading: isPending,
  };
};
